//
// Copyright © 2026 DCM Moguls Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

//
// DCM: two applications that live in Pory's rail and open inside the workbench, each one an
// iframe of a same-origin page DCM serves next to Pory (`/ditz/`, `/brain/`). Same origin is
// the point: Pory's HttpOnly session cookie reaches the page's API without any token handling
// here. Kept in its own plugin so a rebase onto upstream carries it as new folders plus a few
// registration lines, never as edits inside upstream code.
//

import { type Asset, type Plugin, plugin } from '@hcengineering/platform'
import type { AnyComponent } from '@hcengineering/ui'

/** @public */
export const poryId = 'pory' as Plugin

/** Application alias, i.e. the path segment after /workbench/<workspace>/. @public */
export const ditzAppAlias = 'ditz'
/** @public */
export const brainAppAlias = 'brain'

/** @public */
const pory = plugin(poryId, {
  icon: {
    Ditz: '' as Asset,
    Brain: '' as Asset,
    // DCM doors (dcm.7): icons a door in branding.json can name ("icon": "ventures").
    Ventures: '' as Asset,
    Fronte: '' as Asset,
    Suite: '' as Asset,
    Command: '' as Asset,
    Link: '' as Asset,
    Door: '' as Asset
  },
  component: {
    DitzApp: '' as AnyComponent,
    BrainApp: '' as AnyComponent,
    // DCM doors (dcm.7): the one component every iframe door renders, given the door as a prop.
    DoorApp: '' as AnyComponent
  }
})

export default pory
